<div class="min-page-height base-container flex flex-col justify-center items-center text-center">
  <svg-icon
    src="assets/images/svg-icons/icon-404.svg"
    [svgStyle]="{ 'width.px': 104 }"
    class="text-primary mb-16"
  ></svg-icon>

  <h1 class="text-28 md:text-40 font-bold mb-8">Page non trouvée</h1>

  <p class="text-16 text-text-lightest mb-12">
    La page que vous recherchez n'existe pas, ou une autre erreur s'est produite.
  </p>

  <a [routerLink]="['/']" class="btn btn-primary h-24 px-8">Retour à l'accueil</a>
</div>
